<section class="branches">
  <header class="branches-header">
    <strong class="branches-title">{{ data.branches.length === 1 ? 'Local de entrega' : 'Locais de entrega' }}</strong>
    <span class="branches-count">{{ countLabel }}</span>
  </header>

  <ul class="branches-list">
    @for (branch of data.branches; track branch.id) {
      <li class="branches-item">
        <mat-icon
          aria-hidden="true"
          [style.color]="branch.color ?? null"
          >location_on</mat-icon
        >
        <span class="branches-name">{{ branch.name }}</span>
        @if (branch.street) {
          <span class="branches-line">{{ branch.street }}</span>
        }
        @if (branch.city) {
          <span class="branches-line">{{ branch.city }}</span>
        }
      </li>
    }
  </ul>
</section>
